<template>
  <div>
    <!--企业展示-->
    <!--面包屑-->
    <section class="crumbs-wrap">
      <article class="crumbs">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ name: 'Home' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ name: 'exhibition' }">企业展示</el-breadcrumb-item>
        </el-breadcrumb>
      </article>
    </section>
    <!-- tab  -->
    <section class="notice-wrap">
      <div class="notice clearfloat">
        <article class="notice-left">
          <div v-for="(item,itemIndex) in noticeTab" v-show="tabXz==itemIndex" :key="itemIndex" class="notice-left-box">
            <img :src="item.focus.imgUrl | getImg" alt="">
            <div class="popup">
              <p class="popup-title" @click="seeClick( item.focus.id )">{{ item.focus.title }}</p>
              <p class="popup-txt">
                {{ item.focus.content | ellipsisHtml }}
                <span class="popup-more" @click="seeClick( item.focus.id )">【查看详情】</span>
              </p>
              <div class="popup-btn">
                {{ item.focus.releaseTime }}
              </div>
            </div>
          </div>
        </article>
        <!--右侧tab-->
        <article class="notice-right">
          <div class="notice-header">
            <div
              v-for="( item , itemIndex ) in noticeHeader"
              :key="itemIndex"
              :class="[{'notice-header-title-xz':tabXz==itemIndex}]"
              class="notice-header-title"
              @click="tabClick(itemIndex)"
            >{{ item.title }}</div>
          </div>
          <div class="notice-con">
            <div v-for="(con , conIndex) in noticeTab" v-show="tabXz==conIndex" :key="conIndex" class="notice-con-tab">
              <div v-for="(list,listIndex) in con.list" :key="listIndex" class="notice-con-item">
                <div class="notice-item-img"><img :src="list.imgUrl | getImg" alt=""></div>
                <div class="notice-item-con">
                  <p class="con-title" @click="seeClick(list.id)">{{ list.title }}</p>
                  <p class="con-txt" @click="seeClick(list.id)">{{ list.content | ellipsisHtml }}</p>
                  <p class="con-sj">{{ list.releaseTime }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="notice-more">
            <span class="notice-more-sp" @click="seeMoreClick">查看更多>></span>
          </div>
        </article>
      </div>
    </section>
    <!--核心服务-->
    <section class="core-wrap">
      <div class="core">
        <div class="core-header">
          <div class="core-header-title">核心服务项目</div>
        </div>
        <div class="core-main">
          <img class="core-banner" src="../../assets/img/enterprise/core.png" alt="">
          <div v-if="noticeCore[1]" class="core-railway">
            <div class="core-reilway-title" v-html="noticeCore[0].title" />
            <div class="core-reilway-txt" v-html="noticeCore[0].content" />
          </div>
          <div v-if="noticeCore[2]" class="core-tube">
            <div class="core-tube-title" v-html="noticeCore[1].title" />
            <div class="core-tube-txt" v-html="noticeCore[1].content" />
          </div>
          <div v-if="noticeCore[3]" class="core-waterway">
            <div class="core-waterway-title" v-html="noticeCore[2].title" />
            <div class="core-waterway-txt" v-html="noticeCore[2].content" />
          </div>
          <div v-if="noticeCore[0]" class="core-highway">
            <div class="core-highway-title" v-html="noticeCore[3].title" />
            <div class="core-highway-txt" v-html="noticeCore[3].content" />
          </div>

        </div>
      </div>
    </section>
    <!--关于我们-->
    <section class="about-wrap">
      <div class="about">
        <div class="about-header">
          <div v-if="aboutData[0]" class="about-header-title">{{ aboutData[0].title }}</div>
         <p class="about-header-txt">{{ aboutData[0].content }}</p>
        </div>
        <div class="about-main clearfloat">
          <article class="main-item">
            <div class="item-list">
              <div class="list-img"><img src="../../assets/img/enterprise/about1.png" alt=""></div>
              <div class="list-con">
                <p v-if="aboutData[1]" class="list-con-title">{{ aboutData[1].title }}</p>
                <p v-if="aboutData[1]" class="list-con-txt">{{ aboutData[1].content }}</p>
              </div>
            </div>
            <div class="item-list">
              <div class="list-img"><img src="../../assets/img/enterprise/about2.png" alt=""></div>
              <div class="list-con">
                <p v-if="aboutData[2]" class="list-con-title">{{ aboutData[2].title }}</p>
                <p v-if="aboutData[2]" class="list-con-txt">{{ aboutData[2].content }}</p>
              </div>
            </div>
            <div class="item-list">
              <div class="list-img"><img src="../../assets/img/enterprise/about3.png" alt=""></div>
              <div class="list-con">
                <p v-if="aboutData[3]" class="list-con-title">{{ aboutData[3].title }}</p>
                <p v-if="aboutData[3]" class="list-con-txt">{{ aboutData[3].content }}</p>
              </div>
            </div>
          </article>
          <article class="main-img">
            <img src="../../assets/img/enterprise/about.png" alt="">
          </article>
        </div>
      </div>
    </section>
    <!--入驻企业-->
    <!--<section class="enterprise-wrap">-->
    <!--<div class="enterprise">-->
    <!--<div class="enterprise-header">-->
    <!--<div class="enterprise-header-title">入驻企业</div>-->
    <!--<p class="enterprise-header-txt">我司产业定位为 “两大经济、两大产业”即总部经济和信息经济，物流产业和石化产业，重点合作方向为物流运输、石化等领域</p>-->
    <!--</div>-->
    <!--<div class="enterprise-main">-->
    <!--<ul class="clearfloat">-->
    <!--<li><span>海程邦达物流</span></li>-->
    <!--<li><span>青岛锦程物流</span></li>-->
    <!--<li><span>青岛永成物流</span></li>-->
    <!--<li><span>日照山之韵物流</span></li>-->
    <!--<li><span>济宁宇州物流</span></li>-->
    <!--<li><span>宏德物流</span></li>-->
    <!--</ul>-->
    <!--</div>-->
    <!--</div>-->
    <!--</section>-->
  </div>
</template>
<style scoped lang='scss'>
  .crumbs-wrap{
    width: 100%;
    .crumbs{
      width: 1200px;
      margin: 0 auto;
      padding: 40px 0;
    }
  }
  /*tab*/
  .notice-wrap{
    width: 100%;
    padding-bottom: 100px;
    .notice{
      width: 1200px;
      margin: 0 auto;
      .notice-left{
        position: relative;
        width: 600px;
        height: 400px;
        overflow: hidden;
        float: left;
        .notice-left-box{
          width: 520px;
        }
        img{
          width: 100%;
          /*height: 400px;*/
        }
        .popup{
          position: absolute;
          width: 370px;
          height: 220px;
          top: 80px;
          right: 40px;
          padding: 20px 20px 20px 20px;
          background: rgba(242,242,242,0.9);
          -webkit-box-sizing: border-box;
          -moz-box-sizing: border-box;
          box-sizing: border-box;
          .popup-title{
            font-size:14px;
            font-weight:bold;
            padding-bottom: 20px;
            cursor: pointer;
            &:hover{
              color: #BE2316;
            }
          }
          .popup-txt{
            font-size:12px;
            font-weight:400;
            color:#555555;
            line-height:26px;
            .popup-more{
              cursor: pointer;
              &:hover{
                color: #BE2316;
              }
            }
          }
          .popup-btn{
            width:79px;
            height:23px;
            line-height: 23px;
            text-align: center;
            background:#9D9D9D;
            border-radius:2px;
            color: #fff;
            font-size: 12px;
            margin-top: 20px;
            overflow: hidden;
          }
        }
      }
      .notice-right{
        width: 600px;
        height: 400px;
        float: left;
        .notice-header{
          width: 100%;
          height: 40px;
          margin-bottom: 20px;
          border-bottom: 2px solid #C63E33;
          -webkit-box-sizing: border-box;
          -moz-box-sizing: border-box;
          box-sizing: border-box;
          .notice-header-title{
            width: 33%;
            height: 40px;
            line-height: 40px;
            font-size: 16px;
            float: left;
            text-align: center;
            cursor: pointer;
            position: relative;
            color: #555555;
          }
          .notice-header-title-xz{
            font-weight: bold;
            color: #BE2316;
            &:before{
              position: absolute;
              content: '';
              width:0;
              height:0;
              left: 50%;
              margin-left: -3px;
              bottom: 0;
              border-right:6px solid transparent;
              border-left:6px solid transparent;
              border-bottom:6px solid #BE2316;
            }
          }
        }
        .notice-con{
          width: 100%;
          min-height: 300px;
          .notice-con-tab{
            width: 100%;
          }
          .notice-con-item{
            width: 100%;
            margin-top: 12px;
            height: 92px;
            .notice-item-img{
              width: 96px;
              height: 100%;
              margin-right: 20px;
              float: left;
              overflow: hidden;
              img{
                width: 96px;
                height: 100%;
              }
            }
            .notice-item-con{
              position: relative;
              width: 460px;
              height: 92px;
              float: left;
              .con-title{
                font-size: 16px;
                font-weight: bold;
                padding-bottom: 8px;
                padding-top: 4px;
                color: #242424;
                cursor: pointer;
                &:hover{
                  color: #BE2316;
                }
              }
              .con-txt{
                font-size: 14px;
                color:rgba(102,102,102,1);
                padding-bottom: 10px;
                line-height: 19px;
                cursor: pointer;
              }
              .con-txt:hover{
                color: #BE2316;
              }
              .con-sj{
                position: absolute;
                bottom: 0;
                left: 0;
                font-size: 14px;
                color:rgba(153,153,153,1);
              }
            }
          }
        }
        .notice-more{
          width: 100%;
          height: 36px;
          line-height: 36px;
          text-align: right;
          .notice-more-sp{
            font-size: 14px;
            color: #4F83E9;
            cursor: pointer;
          }
        }
      }
    }
  }
  /*核心服务*/
  .core-wrap{
    width: 100%;
    padding-bottom: 100px;
    .core{
      width: 1200px;
      margin: 0 auto;
      .core-header{
        width: 100%;
        height: auto;
        .core-header-title{
          position: relative;
          width: 100%;
          height: 40px;
          font-size: 40px;
          padding-bottom: 15px;
          text-align: center;
          color: #060606;
          &:before{
            position: absolute;
            content: '';
            width: 0;
            height: 0;
            bottom: -10px;
            left: 50%;
            margin-left: -10px;
            border-left: 10px solid transparent;
            border-right: 10px solid transparent;
            border-top: 10px solid #BE2316;
          }
        }
      }
      .core-main{
        position: relative;
        width: 100%;
        height: 486px;
        margin-top: 20px;
        .core-banner{
          position: absolute;
          left: 50%;
          margin-left: -277px;
        }
        /*铁路*/
        .core-railway{
          position: absolute;
          width: 350px;
          left: 15px;
          top: 75px;
          line-height: 20px;
          .core-reilway-title{
            color: #275DC8;
            width: 100%;
            height: 40px;
            font-size:24px;
            text-align: right;
          }
          .core-reilway-txt{
            font-size: 14px;
            color: #636363;
            text-align: right;
          }
        }
        /*管道*/
        .core-tube{
          position: absolute;
          width: 350px;
          left: 845px;
          top: 75px;
          line-height: 20px;
          .core-tube-title{
            color: #275DC8;
            width: 100%;
            height: 40px;
            font-size:24px;
            text-align: left;
          }
          .core-tube-txt{
            font-size: 14px;
            color: #636363;
            text-align: left;
          }
        }
        /*水路*/
        .core-waterway{
          position: absolute;
          width: 350px;
          left: 15px;
          top: 350px;
          line-height: 20px;
          .core-waterway-title{
            color: #275DC8;
            width: 100%;
            height: 40px;
            font-size:24px;
            text-align: right;
          }
          .core-waterway-txt{
            font-size: 14px;
            color: #636363;
            text-align: right;
          }
        }
        /*公路*/
        .core-highway{
          position: absolute;
          width: 350px;
          left: 845px;
          top: 350px;
          line-height: 20px;
          .core-highway-title{
            color: #275DC8;
            width: 100%;
            height: 40px;
            font-size:24px;
            text-align: left;
          }
          .core-highway-txt{
            font-size: 14px;
            color: #636363;
            text-align: left;
          }
        }
      }
    }
  }
  /*关于我们*/
  .about-wrap{
    width: 100%;
    padding-bottom: 100px;
    .about{
      width: 1200px;
      margin: 0 auto;
      .about-header{
        width: 100%;
        height: auto;
        .about-header-title{
          position: relative;
          width: 100%;
          height: 40px;
          font-size: 40px;
          padding-bottom: 15px;
          margin-bottom: 70px;
          text-align: center;
          color: #060606;
          &:before{
            position: absolute;
            content: '';
            width: 0;
            height: 0;
            bottom: -10px;
            left: 50%;
            margin-left: -10px;
            border-left: 10px solid transparent;
            border-right: 10px solid transparent;
            border-top: 10px solid #BE2316;
          }
        }
        .about-header-txt{
          text-align: center;
          font-size: 16px;
          color: #555555;
          margin-top: 35px;

        }
      }
      .about-main{
        width: 100%;
        height: 450px;
        margin-top: 20px;
        .main-item{
          width: 50%;
          height: 450px;
          float: left;
          /*margin-right: 10%;*/
          padding-top: 70px;
          -webkit-box-sizing: border-box;
          -moz-box-sizing: border-box;
          box-sizing: border-box;
          .item-list{
            width: 100%;
            height: 100px;
            margin-bottom: 10px;
            .list-img{
              float: left;
              width: 95px;
              img{
                width: 95px;
              }
            }
            .list-con{
              width: calc(100% - 100px);
              float: left;
              padding-left: 10px;
              -webkit-box-sizing: border-box;
              -moz-box-sizing: border-box;
              box-sizing: border-box;
              .list-con-title{
                font-size: 19px;
                color: #000;
                padding-bottom: 15px;
                font-weight: bold;
              }
              .list-con-txt{
                color: #686868;
                font-size: 14px;
                line-height: 20px;
              }
            }
          }
        }
        .main-img{
          width: 50%;
          height: 450px;
          float: left;
          img{
            float: right;
          }
        }
      }
    }
  }
  /*关于我们*/
  .enterprise-wrap{
    width: 100%;
    min-height: 370px;
    background: url("../../assets/img/enterprise/enterprise.png") no-repeat;
    .enterprise{
      width: 1200px;
      margin: 0 auto;
      padding-top: 50px;
      .enterprise-header{
        width: 100%;
        height: auto;
        .enterprise-header-title{
          position: relative;
          width: 100%;
          height: 40px;
          font-size: 40px;
          padding-bottom: 15px;
          text-align: center;
          color: #060606;
          &:before{
            position: absolute;
            content: '';
            width: 0;
            height: 0;
            bottom: -10px;
            left: 50%;
            margin-left: -10px;
            border-left: 10px solid transparent;
            border-right: 10px solid transparent;
            border-top: 10px solid #BE2316;
          }
        }
        .enterprise-header-txt{
          text-align: center;
          font-size: 16px;
          color: #555555;
          margin-top: 35px;

        }
      }
      .enterprise-main{
        width: 100%;
        min-height: 150px;
        margin-top: 60px;
        ul{
          li{
            width: 150px;
            float: left;
            margin-bottom: 20px;
            span{
              /*cursor: pointer;*/
            }
          }
        }
      }
    }
  }
</style>
<script>
import { exhibitionTab, detailsCore, detailsAbout } from '@/api/enterprise/exhibition'
export default {
  name: 'Exhibition',
  filters: {
    ellipsis(value) {
      if (!value) return ''
      if (value.length > 50) {
        return value.slice(0, 50) + '...'
      }
      return value
    },
    ellipsisHtml(value) {
      if (!value) return ''
      var msg = value.replace(/<[^<>]+>/g, '').replace(/&nbsp;/ig, '').replace(/^\s+|\s+$/g, '')
      if (msg.length > 50) {
        return msg.slice(0, 50) + '...'
      }
      return msg
    }
  },
  data() {
    return {
      // tab切换
      tabXz: 0,
      noticeTab: [],
      noticeHeader: [
        { title: '平台公告' },
        { title: '企业新闻' },
        { title: '行业动态' }
      ],
      // 核心服务
      noticeCore: [],
      //  关于我们
      aboutData: []
    }
  },
  created() {
    // tab切换
    exhibitionTab().then(res => {
      this.noticeTab = res.result
    }).catch(error => {
      console.log(error)
    })
    // 核心服务
    detailsCore().then(res => {
      this.noticeCore = res.result
    }).catch(error => {
      console.log(error)
    })
    // 关于我们
    detailsAbout().then(res => {
      this.aboutData = res.result
    }).catch(error => {
      console.log(error)
    })
  },
  methods: {
    // tab切换
    tabClick(index) {
      this.tabXz = index
    },
    // 查看更多
    seeMoreClick() {
      this.$router.push({
        name: 'list'
      })
    },
    // 查看详情
    seeClick(data) {
      this.$router.push({
        name: 'detailsSee', query: { seeID: data }
      })
    }
  }
}
</script>
